import { render, staticRenderFns } from "./PostModelList.vue?vue&type=template&id=5b7213d5&scoped=true"
import script from "./PostModelList.vue?vue&type=script&lang=js"
export * from "./PostModelList.vue?vue&type=script&lang=js"
import style0 from "./PostModelList.vue?vue&type=style&index=0&id=5b7213d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7213d5",
  null
  
)

export default component.exports